import React from "react";
import { FeatureGroup } from "react-leaflet";
import PropTypes from "prop-types";

import { LayerType, RefType } from "./types";
import Geofence from "./Geofence";

const GeofenceLayer = ({
  layersRef,
  groupPolygonsRef,
  layer,
  polygonsRef,
  mapSettings,
  sidewalksMode,
}) => (
  <FeatureGroup
    ref={(node) => {
      layersRef.current[layer.key] = node;
    }}
  >
    {Object.values(layer.zones)
      .filter((zone) => !zone.hidden)
      .map((zone) => (
        <Geofence
          {...mapSettings}
          zone={zone}
          key={zone.key}
          groupPolygonsRef={groupPolygonsRef}
          polygonsRef={polygonsRef}
          layer={layer}
          sidewalksMode={sidewalksMode}
        />
      ))}
  </FeatureGroup>
);

GeofenceLayer.propTypes = {
  mapSettings: PropTypes.shape({
    zoom: PropTypes.number,
    bounds: PropTypes.object,
  }).isRequired,
  layer: LayerType.isRequired,
  layersRef: RefType.isRequired,
  polygonsRef: RefType.isRequired,
  groupPolygonsRef: RefType.isRequired,
  sidewalksMode: PropTypes.bool,
};

GeofenceLayer.defaultProps = {
  sidewalksMode: false,
};

export default GeofenceLayer;
